<div [ngSwitch]="selectedAdType">
  <div *ngSwitchCase="AdTypes.DYNAMIC_CREATIVE_ADS">
    <aayn-dynamic-creative-ads-preview--tiktok></aayn-dynamic-creative-ads-preview--tiktok>
  </div>
</div>
